// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { NgModule } from '@angular/core';

//Components
import { HealthCheckComponent } from './components/health-check';

//Modules
import { SharedModule } from '../shared/shared.module';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
export const HealthCheckRoutes = [
    { path:"healthcheck", component:HealthCheckComponent }
];

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// HealthCheckModule
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@NgModule({
  imports:[
    SharedModule
  ],
  declarations:[
    HealthCheckComponent
  ],
  providers:[],
  exports:[]
})
export class HealthCheckModule{}
